export default function Grain() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[90] opacity-[0.05] mix-blend-multiply"
      style={{
        backgroundImage: "radial-gradient(#6E1633 0.6px, transparent 0.6px)",
        backgroundSize: "14px 14px",
      }}
    />
  );
}
